// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3Nlj0","cardContent":"Card_cardContent__34zPM","img":"Card_img__3PQ_F","title":"Card_title__3fG9w","text":"Card_text__2s6Y9","cardText":"Card_cardText__3Mn1b"};